import React from 'react';

import { IFriendGameContext } from './types';

export const FriendGameContext = React.createContext<IFriendGameContext>({
  isLoading: true,
  inviteId: '',
  playerId: '',
  accept: Promise.resolve,
  delete: Promise.resolve,
});
